// import { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import TableView2 from "./TableView2";

// const NewDashboard = ({ handleLogout }) => {
//   const [input1, setInput1] = useState("");
//   const [input2, setInput2] = useState("");
//   const [input3, setInput3] = useState("");
//   const [input4, setInput4] = useState("");
//   const [calculationResult, setCalculationResult] = useState("");
//   const [error, setError] = useState("");
//   const printRef = useRef();
//   const isMobile = useIsMobile(768);
//   function useIsMobile(breakpoint = 768) {
//     const [isMobile, setIsMobile] = useState(
//       () => window.innerWidth <= breakpoint
//     );
//     useEffect(() => {
//       const onResize = () => setIsMobile(window.innerWidth <= breakpoint);
//       window.addEventListener("resize", onResize);
//       return () => window.removeEventListener("resize", onResize);
//     }, [breakpoint]);
//     return isMobile;
//   }

//   useEffect(() => {
//     setCalculationResult("");
//   }, [input1, input2, input3, input4]);

//   useEffect(() => {
//     let timeout;
//     if (error === "Failed to authenticate token.") {
//       timeout = setTimeout(() => {
//         handleLogout();
//       }, 3000);
//     }
//     return () => clearTimeout(timeout);
//   }, [error]);

//   const handleCalculate = async () => {
//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.post(
//         process.env.REACT_APP_API_URL + "/calculate",
//         {
//           input1: Number(input1),
//           input2,
//           input3: Number(input3),
//           input4,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       if (response?.message) {
//         setCalculationResult(response?.message);
//       } else {
//         setCalculationResult(response?.data?.result);
//       }
//     } catch (error) {
//       setCalculationResult("");
//       setError(error.response.data.message);
//     }
//   };

//   const handlePrint = () => {
//     const printContents = printRef.current.innerHTML;
//     const originalContents = document.body.innerHTML;

//     document.body.innerHTML = printContents;
//     window.print();
//     document.body.innerHTML = originalContents;
//   };

//   return (
//     <main className="main">
//       <div className="topbar">
//         <div className="topbar__brand">
//           <span className="crumbs">Dashboard</span>
//         </div>
//       </div>

//       <div className="content">
//         <section className="card">
//           <header className="card__head">
//             <div className="card__title">Land Info and Calculation</div>
//           </header>
//           <div className="form">
//             <div className="field">
//               <label className="label">Sales Price</label>
//               <input
//                 className="input"
//                 type="number"
//                 placeholder="Enter sales price"
//                 value={input1}
//                 onChange={(e) => {
//                   const value = Number(e.target.value);
//                   if (value >= 0 || e.target.value === "") {
//                     setInput1(e.target.value);
//                   }
//                 }}
//               />
//             </div>
//             <div className="field">
//               <label className="label">Zone</label>
//               <select
//                 className="select"
//                 value={input2}
//                 onChange={(e) => setInput2(e.target.value)}
//               >
//                 <option value="">Select Zone</option>
//                 <option value="CHENNAI">Chennai</option>
//                 <option value="BANGALORE">Bangalore</option>
//                 <option value="HYDERABAD">Hyderabad</option>
//                 <option value="PUNE">Pune</option>
//                 <option value="COIMBATORE">Coimbatore</option>
//                 <option value="DELHI-NCR">Delhi-NCR</option>
//               </select>
//             </div>
//             <div className="field">
//               <label className="label">FSI (Floor Space Index)</label>
//               <input
//                 className="input"
//                 type="number"
//                 step="0.1"
//                 min="0"
//                 placeholder="Enter FSI value"
//                 value={input3}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (value === "" || Number(value) >= 0) {
//                     setInput3(value);
//                   }
//                 }}
//               />
//             </div>
//             <div className="field">
//               <label className="label">Type of Development</label>
//               <select
//                 className="select"
//                 value={input4}
//                 onChange={(e) => setInput4(e.target.value)}
//               >
//                 <option value="">Select Development Type</option>
//                 <option value="VILLA">Villa</option>
//                 <option value="LOWRISE">Low Rise</option>
//                 <option value="MSB">MSB</option>
//               </select>
//             </div>
//           </div>
//           {!calculationResult && (
//             <>
//               <div className="hero">
//                 <div className="hero__box">
//                   <svg
//                     width="120"
//                     height="120"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     stroke="#2e7cc5"
//                     strokeWidth="2"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   >
//                     <circle cx="11" cy="11" r="7" />
//                     <line x1="21" y1="21" x2="16.65" y2="16.65" />
//                   </svg>
//                   <div className="hero__note">
//                     No Calculated Land Values Found
//                     <br />
//                     Give your values and get the details
//                   </div>
//                 </div>
//               </div>
//               <div className="cta">
//                 <button
//                   className="btn-primary"
//                   disabled={!input1 || !input2 || !input3 || !input4}
//                   onClick={handleCalculate}
//                 >
//                   Calculate Land Values
//                 </button>
//               </div>
//             </>
//           )}
//           {calculationResult && (
//             <div>
//               <div ref={printRef}>
//                 <div className="card-header print-only">
//                   <img
//                     className="img-logo"
//                     src="/Casagrand-Logo1.webp"
//                     alt="logo"
//                     width={200}
//                   />
//                   <h2 className="padding-10">Land Info and Calculation</h2>
//                 </div>
//                 <div className="padding-20">
//                   <table class="table-view">
//                     <thead>
//                       <tr>
//                         <th className="table-head-font width-25p">
//                           Sales Price
//                         </th>
//                         <th className="table-head-font width-25p">zone</th>
//                         <th className="table-head-font width-25p">FSI</th>
//                         <th className="table-head-font width-25p">
//                           Type of Development
//                         </th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       <tr>
//                         <td className="ft-w-500 width-25p">{input1}</td>
//                         <td className="ft-w-500 width-25p">{input2}</td>
//                         <td className="ft-w-500 width-25p">{input3}</td>
//                         <td className="ft-w-500 width-25p">{input4}</td>
//                       </tr>
//                     </tbody>
//                   </table>
//                 </div>
//                 <div className="print-btn-wrapper">
//                   <button
//                     className="btn-primary h-3rem print-btn-h"
//                     onClick={handlePrint}
//                   >
//                     Print
//                   </button>
//                 </div>
//                 <TableView2 calculationResult={calculationResult} />
//               </div>
//             </div>
//           )}
//         </section>
//       </div>
//     </main>
//   );
// };

// export default NewDashboard;

import { useEffect, useRef, useState } from "react";
import axios from "axios";
import TableView2 from "./TableView2";
import { useReactToPrint } from "react-to-print";

const NewDashboard = ({ handleLogout }) => {
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const [input3, setInput3] = useState("");
  const [input4, setInput4] = useState("");
  const [inputCopy, setInputCopy] = useState({});
  const [calculationResult, setCalculationResult] = useState("");
  const [error, setError] = useState("");

  const printRef = useRef(null);

  const isMobile = useIsMobile(768);
  function useIsMobile(breakpoint = 768) {
    const [isMobile, setIsMobile] = useState(
      () => window.innerWidth <= breakpoint
    );
    useEffect(() => {
      const onResize = () => setIsMobile(window.innerWidth <= breakpoint);
      window.addEventListener("resize", onResize);
      return () => window.removeEventListener("resize", onResize);
    }, [breakpoint]);
    return isMobile;
  }

  // useEffect(() => {
  //   setCalculationResult("");
  // }, [input1, input2, input3, input4]);

  const clearOnUserEdit = () => {
    if (calculationResult) {
      setCalculationResult("");
      setError("");
    }
  };

  useEffect(() => {
    let timeout;
    if (error === "Failed to authenticate token.") {
      timeout = setTimeout(() => {
        handleLogout();
      }, 3000);
    }
    return () => clearTimeout(timeout);
  }, [error]);

  const handleCalculate = async () => {
    setInputCopy({
      input1: input1,
      input2: input2,
      input3: input3,
      input4: input4,
    });
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/calculate",
        {
          input1: Number(input1),
          input2,
          input3: Number(input3),
          input4,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.message) {
        setCalculationResult(response?.message);
      } else {
        setCalculationResult(response?.data?.result);
      }
    } catch (error) {
      setCalculationResult("");
      setError(error.response?.data?.message || "Error");
    }
    setInput1("");
    setInput2("");
    setInput3("");
    setInput4("");
  };

  // NEW: react-to-print handler (replaces your DOM-swap print)
  const handlePrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: "Land Info and Calculation",
    // If you need to force a small reflow after print on some browsers:
    // onAfterPrint: () => window.dispatchEvent(new Event("resize")),
  });

  return (
    <main className="main">
      <div className="topbar">
        <div className="topbar__brand">
          <span className="crumbs">Dashboard</span>
        </div>
      </div>

      <div className="content">
        <section className="card">
          <header className="card__head">
            <div className="card__title">Land Info and Calculation</div>
          </header>

          <div className="form">
            <div className="field">
              <label className="label">Sales Price</label>
              <input
                className="input"
                type="number"
                placeholder="Enter sales price"
                value={input1}
                onChange={(e) => {
                  const value = Number(e.target.value);
                  if (value >= 0 || e.target.value === "") {
                    clearOnUserEdit();
                    setInput1(e.target.value);
                  }
                }}
              />
            </div>

            <div className="field">
              <label className="label">Zone</label>
              <select
                className="select"
                value={input2}
                onChange={(e) => {
                  clearOnUserEdit();
                  setInput2(e.target.value);
                }}
              >
                <option value="">Select Zone</option>
                <option value="CHENNAI">Chennai</option>
                <option value="BANGALORE">Bangalore</option>
                <option value="HYDERABAD">Hyderabad</option>
                <option value="PUNE">Pune</option>
                <option value="COIMBATORE">Coimbatore</option>
                <option value="DELHI-NCR">Delhi-NCR</option>
                <option value="ANDHRA-PRADESH">Andhra-Pradesh</option>
              </select>
            </div>

            <div className="field">
              <label className="label">FSI (Floor Space Index)</label>
              <input
                className="input"
                type="number"
                step="0.1"
                min="0"
                placeholder="Enter FSI value"
                value={input3}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "" || Number(value) >= 0) {
                    clearOnUserEdit();
                    setInput3(value);
                  }
                }}
              />
            </div>

            <div className="field">
              <label className="label">Type of Development</label>
              <select
                className="select"
                value={input4}
                onChange={(e) => {
                  clearOnUserEdit();
                  setInput4(e.target.value);
                }}
              >
                <option value="">Select Development Type</option>
                <option value="VILLA">Villa</option>
                <option value="LOWRISE">Low Rise</option>
                <option value="MSB">MSB</option>
              </select>
            </div>
          </div>

          {!calculationResult && (
            <>
              <div className="hero">
                <div className="hero__box">
                  <svg
                    width="120"
                    height="120"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#2e7cc5"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="11" cy="11" r="7" />
                    <line x1="21" y1="21" x2="16.65" y2="16.65" />
                  </svg>
                  <div className="hero__note">
                    No Calculated Land Values Found
                    <br />
                    Give your values and get the details
                  </div>
                </div>
              </div>
              <div className="cta">
                <button
                  className="btn-primary"
                  disabled={!input1 || !input2 || !input3 || !input4}
                  onClick={handleCalculate}
                >
                  Calculate Land Values
                </button>
              </div>
            </>
          )}

          {calculationResult && (
            <div>
              <div ref={printRef}>
                <div className="card-header print-only">
                  <img
                    className="img-logo"
                    src="/Casagrand-Logo1.webp"
                    alt="logo"
                    width={200}
                  />
                  <h2 className="padding-10">Land Info and Calculation</h2>
                </div>

                <div className="padding-20">
                  <table className="table-view">
                    <thead>
                      <tr>
                        <th className="table-head-font width-25p">
                          Sales Price
                        </th>
                        <th className="table-head-font width-25p">zone</th>
                        <th className="table-head-font width-25p">FSI</th>
                        <th className="table-head-font width-25p">
                          Type of Development
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="ft-w-500 width-25p">
                          {inputCopy.input1}
                        </td>
                        <td className="ft-w-500 width-25p">
                          {inputCopy.input2}
                        </td>
                        <td className="ft-w-500 width-25p">
                          {inputCopy.input3}
                        </td>
                        <td className="ft-w-500 width-25p">
                          {inputCopy.input4}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="print-btn-wrapper">
                  <button
                    className="btn-primary h-3rem print-btn-h"
                    onClick={handlePrint}
                  >
                    Print
                  </button>
                </div>

                <TableView2 calculationResult={calculationResult} />
              </div>
            </div>
          )}
        </section>
      </div>
    </main>
  );
};

export default NewDashboard;
